var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconModalOrcamentoAtividade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6915 15.5242C9.76903 15.9063 8.78018 16.1024 7.78174 16.1011C6.7833 16.1023 5.79446 15.9063 4.87203 15.5242C3.94959 15.1421 3.11176 14.5815 2.40668 13.8746C1.69974 13.1695 1.13912 12.3317 0.757021 11.4092C0.374924 10.4868 0.178888 9.49795 0.180182 8.49951C0.178909 7.50108 0.374954 6.51223 0.75705 5.5898C1.13915 4.66737 1.69976 3.82954 2.40668 3.12445C3.11176 2.41753 3.94959 1.85692 4.87203 1.47482C5.79446 1.09273 6.7833 0.896683 7.78174 0.897956C8.78018 0.896662 9.76903 1.0927 10.6915 1.47479C11.6139 1.85689 12.4517 2.41752 13.1568 3.12445C13.8637 3.82954 14.4243 4.66737 14.8064 5.5898C15.1885 6.51223 15.3846 7.50108 15.3833 8.49951C15.3846 9.49795 15.1886 10.4868 14.8065 11.4092C14.4244 12.3317 13.8637 13.1695 13.1568 13.8746C12.4517 14.5815 11.6139 15.1421 10.6915 15.5242ZM11.7328 6.74937C12.0257 6.45648 12.0257 5.9816 11.7328 5.68871C11.4399 5.39582 10.965 5.39582 10.6721 5.68871L6.6415 9.71931L4.89136 7.96918C4.59847 7.67628 4.1236 7.67628 3.8307 7.96918C3.53781 8.26207 3.53781 8.73694 3.8307 9.02984L6.11117 11.3103C6.40406 11.6032 6.87894 11.6032 7.17183 11.3103L11.7328 6.74937Z",
    fill: "#34639C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalOrcamentoAtividade);
export default __webpack_public_path__ + "static/media/IconModalOrcamentoAtividade.3544032f07226fec4fd3b42529da0a54.svg";
export { ForwardRef as ReactComponent };